import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { Row, Col, Button } from 'react-bootstrap';
import { sendAlert } from '../../actions/utils';
import { useAuthorization } from '../../services/hooks';
import { camelCaseEmptyStringRecursive, delayMethod } from '../../services/utils';
import TicketDataTable from './TicketDataTable';
import { SimpleCenteredModal } from '../../components';
import { showEmployeeRequest } from '../../requests/employees';
import { createTicketRequest } from '../../requests/tickets';
import columns from './Columns';
import TicketForm from './TicketForm';

const TicketIndex = () => {
  const { currentEmployee } = useSelector(state => state.auth);
  const [modalBody, setModalBody] = useState('');
  const [moreData, setMoreData] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [employee, setEmployee] = useState({});
  const dispatch = useDispatch();

  const handleSuccessCreate = message => {
    dispatch(sendAlert({ kind: 'success', message }));
    setMoreData(!moreData);
    setModalShow(false);
  };

  const handleFailureRequest = error => {
    const { response } = error;
    dispatch(sendAlert({ kind: 'error', message: response?.data?.message }));
  };

  const handleCreate = ticket => {
    createTicketRequest({
      dispatch,
      params: snakeCaseKeys(ticket),
      successCallback: () => handleSuccessCreate('Ticket creado con éxito'),
      failureCallback: handleFailureRequest
    });
  };

  const fetchEmployee = () => {
    if (currentEmployee) {
      showEmployeeRequest(currentEmployee, {
        dispatch,
        params: { active: true },
        successCallback: response => {
          setEmployee(camelCaseEmptyStringRecursive(response.data));
        }
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(fetchEmployee, [currentEmployee]);

  const newTicket = () => {
    const currentTicket = {
      employeeId: currentEmployee || '',
      phoneCountryCode: employee.phoneCountryCode || '+56',
      phone: employee.phone || '',
      email: employee.workEmail || employee.email || '',
      viaEmail: false,
      viaPhone: false,
      description: ''
    };

    setModalShow(true);
    setModalBody(
      <TicketForm
        action="new"
        handleModalClose={() => delayMethod(() => setModalShow(false))}
        employee={employee}
        ticket={currentTicket}
        formRequest={handleCreate}
      />
    );
  };

  return (
    <>
      <Row className="mt-4 mb-1">
        <Col>
          <h2 className="mt-3">Soporte</h2>
        </Col>
        <Col md={3} xl={2}>
          {useAuthorization('create', 'Ticket') && (
            <Button variant="primary" className="mt-3" block onClick={() => newTicket()}>
              Nuevo Ticket
            </Button>
          )}
        </Col>
      </Row>
      <TicketDataTable columns={columns} moreData={moreData} />
      <SimpleCenteredModal title="Nuevo Ticket" body={modalBody} show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
};

export default TicketIndex;
